exports.API_PREFIX = process.env.GATSBY_API_URL ? new URL(process.env.GATSBY_API_URL).pathname : "/api";
